import {
  LOGIN,
  REDIRECT,
  TRUSTED_HOSTS,
  LOCALHOST,
} from '../../constants/constants';

function findRedirectURL(search: URLSearchParams): string | undefined {
  let url = search.get(REDIRECT);
  if (url) {
    if (url.includes(LOGIN)) url = url.replace(LOGIN, '');
    if (url.startsWith(LOCALHOST)) return url;
    if (url.match(TRUSTED_HOSTS)) return url;
  }
  return undefined;
}

const redirect = (
  location: any,
  language: string,
  token: string,
  userId: string,
  appUrl: string,
) => {
  const search = new URLSearchParams(location.search);
  const url = findRedirectURL(search) || appUrl;
  const concatenator = url.includes('?') ? '&' : '?';

  window.location.replace(
    `${url}${concatenator}lang=${language}&token=${token}&user=${userId}`,
  );
};

export default redirect;
